import { clients } from '@/lib/https';

export interface SendMailPayload {
  subjectDataContext?: Record<string, string> | null;
  to?: string[] | null;
  bcc?: string[] | null;
  cc?: string[] | null;
  purpose?: string | null;
  language?: string | null;
  replyTo?: string[] | null;
  attachments?: string[] | null;
  bodyDataContext?: Record<string, string> | null;
  sendPhoneNumberAsEmail?: boolean;
  projectKey?: string | null;
}

/**
 * Sends a template-based email through the Blocks Communication API.
 *
 * The `purpose` identifies the configured email template, while the subject
 * and body data contexts provide values for that template's placeholders.
 */
export const sendMail = (payload: SendMailPayload): Promise<unknown> => {
  return clients.post<unknown>(
    '/communication/v1/Mail/Send',
    JSON.stringify(payload)
  );
};
